import ContactUs from "../../component/contact us/ContactUs";


const CONTACTuS=()=>{
  return(
    <div className="CONTACTuS">
      <ContactUs/>
    </div>
  )
}

export default CONTACTuS;